import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/e-commerce.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Revolutionize Your Operations"
				subtitle=""
				breadcrumbText="Cloud solutions"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}